// extracted by mini-css-extract-plugin
export default {"richMessageBox":"OmAhlhaXXvir0lUNdRkK"};